(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["campaign-description"] && !Shopify.designMode) return;
  try {
    
  /* Glides the page down to the anchor of the "see more" link instead of
     jumping to it, with the duration, easing and offset of the original. This
     animation is one of the few of the theme, and was asked for. */
  const SCROLL_DURATION = 2000;
  const SCROLL_EASING = 2; /* easeOutQuad, the easing the original names. */
  const SCROLL_OFFSET = 225; /* The target lands that far below the top edge. */

  class CampaignDescription extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick);
    }

    onClick = (event) => {
      const link = event.target.closest('.campaign-description__more');
      if (!link) return;

      /* No target on the page (a campaign without credits): the link is left
         to the browser, which has nothing to scroll to either. */
      const target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      event.preventDefault();
      this.glideTo(target);
    };

    glideTo(target) {
      const from = window.scrollY;
      const max = document.documentElement.scrollHeight - window.innerHeight;
      const to = Math.max(0, Math.min(max, target.getBoundingClientRect().top + from - SCROLL_OFFSET));
      if (to === from) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        window.scrollTo(0, to);
        return;
      }

      let start = null;
      const step = (now) => {
        if (start === null) start = now;
        const progress = Math.min(1, (now - start) / SCROLL_DURATION);
        const eased = 1 - Math.pow(1 - progress, SCROLL_EASING);
        window.scrollTo(0, from + (to - from) * eased);
        if (progress < 1) requestAnimationFrame(step);
      };
      requestAnimationFrame(step);
    }
  }

  if (!customElements.get('campaign-description')) {
    customElements.define('campaign-description', CampaignDescription);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["campaign-gallery"] && !Shopify.designMode) return;
  try {
    
  class CampaignGallery extends HTMLElement {
    connectedCallback() {
      this.querySelectorAll('.campaign-gallery__image').forEach((image) => {
        if (image.complete && image.naturalWidth > 0) image.classList.add('is-loaded');
        else image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
      });
    }
  }

  customElements.define('campaign-gallery', CampaignGallery);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-seo"] && !Shopify.designMode) return;
  try {
    
  /*
   * <collection-seo>: clamps the text to three lines and unfolds it on demand.
   * The toggle is only revealed when the clamped text actually overflows, and
   * that is measured again whenever the text changes width.
   */
  if (!customElements.get('collection-seo')) {
    customElements.define(
      'collection-seo',
      class extends HTMLElement {
        connectedCallback() {
          this.text = this.querySelector('[data-seo-text]');
          this.toggle = this.querySelector('[data-seo-toggle]');
          if (!this.text || !this.toggle) return;

          this.toggle.addEventListener('click', () => this.setExpanded(!this.expanded));
          this.observer = new ResizeObserver(() => this.measure());
          this.observer.observe(this.text);
        }

        disconnectedCallback() {
          this.observer?.disconnect();
        }

        get expanded() {
          return this.toggle.getAttribute('aria-expanded') === 'true';
        }

        setExpanded(expanded) {
          this.toggle.setAttribute('aria-expanded', String(expanded));
          this.toggle.textContent = expanded ? this.toggle.dataset.labelLess : this.toggle.dataset.labelMore;
          this.classList.toggle('is-expanded', expanded);
        }

        // Unfolded, the text no longer tells whether it would overflow: the
        // button stays, since it is the way back.
        measure() {
          if (this.expanded) return;
          this.toggle.hidden = this.text.scrollHeight <= this.text.clientHeight + 1;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["contact"] && !Shopify.designMode) return;
  try {
    
  /* Completes the host variables above inside the Shopify Forms shadow root:
     the field gap, the uppercase text, the height of the message area and the
     button width are hard-coded in the app's own classes. Element selectors
     only, so an app release renaming its hashed classes changes nothing here;
     if the shadow root ever closes, the variables still apply. */
  class ContactForm extends HTMLElement {
    connectedCallback() {
      this.style();
      this.observer = new MutationObserver(() => this.style());
      this.observer.observe(this, { childList: true, subtree: true });
    }

    disconnectedCallback() {
      this.observer.disconnect();
    }

    style() {
      const host = this.querySelector('shopify-forms-embed');
      if (!host || !host.shadowRoot || this.sheet) return;
      this.sheet = new CSSStyleSheet();
      this.sheet.replaceSync(`
        /* The app clips its container and keeps a 2px margin and padding
           around the form for the focus ring; the ring is drawn outside
           instead and the form aligns with the column. */
        form { gap: 2px !important; padding: 0 !important; }
        section { overflow: visible !important; }
        section section { margin: 0 !important; }
        form input, form textarea, form button, form label, form p, form span {
          text-transform: uppercase !important;
          letter-spacing: -0.01em !important;
        }
        form label { transform-origin: left top !important; }
        /* The app masks the top of the message area with a coloured strip so
           the floating label stays readable while scrolling; with our smaller
           font that strip covered the first line. Text starts below it. */
        form textarea {
          box-sizing: border-box !important;
          height: 200px !important;
          min-height: 0 !important;
          padding-top: 26px !important;
        }
        form div:has(> textarea)::before { height: 24px !important; }
        /* Errors: a 1px ring instead of 2px, and the message 2px below the
           field (the form gap) and 4px above the next one. The textarea and
           the select carry no aria-invalid, hence the class-word selectors. */
        form :is(input, textarea, button)[aria-invalid="true"],
        form div[class*="withError"] > input,
        form textarea[class*="invalid"],
        form button[class*="Error"] {
          box-shadow: 0 0 0 1px var(--form-error-color) !important;
        }
        form output { margin: 2px 0 !important; line-height: 16px !important; }
        form > output { margin-top: 0 !important; }
        form output + button[type="submit"] { margin-top: 0 !important; }
        form button[type="submit"] {
          box-sizing: border-box !important;
          width: 100% !important;
          height: 40px !important;
          margin-top: 8px !important;
          line-height: 16px !important;
        }
      `);
      host.shadowRoot.adoptedStyleSheets = [...host.shadowRoot.adoptedStyleSheets, this.sheet];
      this.observer.disconnect();
    }
  }

  if (!customElements.get('contact-form')) {
    customElements.define('contact-form', ContactForm);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  /*
    WhatsApp availability. Computed once, when the element is attached:
    the visitor's current instant is expressed in Paris time and compared
    with the opening hours of the theme settings (Contact details). The server renders the
    "unavailable" state, so nothing shows green until confirmed.
  */
  class FooterWhatsappStatus extends HTMLElement {
    connectedCallback() {
      if (this.isAvailable()) {
        this.textContent = this.dataset.available;
        this.classList.add('footer__status--available');
      }
    }

    isAvailable() {
      const open = this.toMinutes(this.dataset.open);
      const close = this.toMinutes(this.dataset.close);
      if (open === null || close === null) return false;

      let parts;
      try {
        parts = new Intl.DateTimeFormat('en-GB', {
          timeZone: 'Europe/Paris',
          weekday: 'short',
          hour: '2-digit',
          minute: '2-digit',
          hourCycle: 'h23',
        }).formatToParts(new Date());
      } catch (error) {
        return false;
      }

      const get = (type) => (parts.find((part) => part.type === type) || {}).value;
      const weekday = get('weekday');
      const now = Number(get('hour')) * 60 + Number(get('minute'));

      if (this.dataset.weekdays === 'true' && (weekday === 'Sat' || weekday === 'Sun')) return false;
      return now >= open && now < close;
    }

    toMinutes(value) {
      const match = /^(\d{1,2}):(\d{2})$/.exec((value || '').trim());
      if (!match) return null;
      const hours = Number(match[1]);
      const minutes = Number(match[2]);
      if (hours > 24 || minutes > 59) return null;
      return hours * 60 + minutes;
    }
  }

  if (!customElements.get('footer-whatsapp-status')) {
    customElements.define('footer-whatsapp-status', FooterWhatsappStatus);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["image-slider"] && !Shopify.designMode) return;
  try {
    
  /**
   * Steps the carousel from one image to the next, and keeps the two arrows in
   * step with the scroll position — including the scroll made with a finger or
   * a trackpad, which is why the state is read from the scroll event rather
   * than counted here.
   */
  class ImageSlider extends HTMLElement {
    /* Images travelled per click on an arrow. */
    static STEP = 2;

    connectedCallback() {
      this.list = this.querySelector('[data-slider-list]');
      this.prev = this.querySelector('[data-slider-prev]');
      this.next = this.querySelector('[data-slider-next]');

      if (!this.list) return;

      this.prev?.addEventListener('click', () => this.step(-1));
      this.next?.addEventListener('click', () => this.step(1));

      this.onScroll = () => {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.syncArrows());
      };

      this.list.addEventListener('scroll', this.onScroll, { passive: true });
      window.addEventListener('resize', this.onScroll, { passive: true });
      this.syncArrows();
    }

    disconnectedCallback() {
      this.list?.removeEventListener('scroll', this.onScroll);
      window.removeEventListener('resize', this.onScroll);
      cancelAnimationFrame(this.frame);
    }

    /**
     * Scrolls two images forwards or back, landing on a snap point either way.
     * The step is counted in images rather than in pixels so the carousel comes
     * to rest on an image whatever its number or its width; the browser clamps
     * the last step, which leaves the final image flush against the right edge.
     */
    step(direction) {
      const starts = [...this.list.children].map((item) => item.offsetLeft);
      const current = this.list.scrollLeft;

      /* Index of the image the carousel currently starts on. */
      let index = 0;
      starts.forEach((start, i) => {
        if (start <= current + 1) index = i;
      });

      const wanted = index + direction * ImageSlider.STEP;
      const target = starts[Math.min(starts.length - 1, Math.max(0, wanted))];

      if (target === undefined || target === current) return;

      const motionless = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.list.scrollTo({ left: target, behavior: motionless ? 'auto' : 'smooth' });
    }

    /** An arrow with nothing left to reach is disabled, as on the original. */
    syncArrows() {
      const { scrollLeft, scrollWidth, clientWidth } = this.list;

      if (this.prev) this.prev.disabled = scrollLeft <= 1;
      if (this.next) this.next.disabled = scrollLeft >= scrollWidth - clientWidth - 1;
    }
  }

  if (!customElements.get('image-slider')) {
    customElements.define('image-slider', ImageSlider);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["materials"]) return;
  try {
    
  class MaterialsIndex extends HTMLElement {
    connectedCallback() {
      this.popin = this.querySelector('.materials__popin');
      this.panel = this.querySelector('.materials__panel');
      this.content = this.querySelector('.materials__content');
      this.products = this.querySelector('.materials__products');
      this.slider = this.querySelector('.materials__slider');
      this.arrows = [...this.querySelectorAll('.materials__arrow')];
      this.lists = new Map();

      this.grid = this.querySelector('.materials__grid');
      this.more = this.querySelector('.materials__more');
      this.batch = Number(this.dataset.batch) || 48;

      this.fadeIn(this.querySelectorAll('.materials__image'));

      /* Delegated: cards of the other pages are added later. */
      this.grid.addEventListener('click', (event) => {
        const button = event.target.closest('.materials__open');
        if (button) this.open(button.closest('.materials__item'));
      });

      this.more.querySelector('button').addEventListener('click', () => this.showMore(true));
      this.prepare();

      this.querySelector('.materials__overlay').addEventListener('click', () => this.popin.close());
      this.querySelector('.materials__close').addEventListener('click', () => this.popin.close());
      this.popin.addEventListener('close', () => this.clearProducts());

      this.arrows.forEach((arrow) => {
        arrow.addEventListener('click', () => this.step(Number(arrow.dataset.direction)));
      });
    }

    /* The panel of the card, cloned out of its template. A modal dialog gives
       the rest: Escape, the focus kept inside and given back to the card. */
    open(item) {
      const template = item.querySelector('.materials__data');
      this.content.replaceChildren(template.content.cloneNode(true));
      this.fadeIn(this.content.querySelectorAll('img'));
      this.clearProducts();
      this.popin.showModal();
      this.loadProducts(item.dataset.materialId);
    }

    /* Liquid cannot look products up by metafield value: the list comes from
       the `materials-products` section, rendered on the products collection
       filtered on this entry. Each list is fetched once, then cloned. */
    async loadProducts(id) {
      if (!id) return;
      this.pending = id;

      let list = this.lists.get(id);
      if (list === undefined) {
        const filter = encodeURIComponent('gid://shopify/Metaobject/' + id);
        const url = `${this.dataset.productsUrl}?section_id=materials-products&filter.p.m.custom.materials=${filter}`;
        try {
          const html = await fetch(url).then((response) => response.text());
          list = new DOMParser().parseFromString(html, 'text/html').querySelector('.materials__products-list');
        } catch (error) {
          list = null;
        }
        this.lists.set(id, list);
      }

      if (!list || this.pending !== id || !this.popin.open) return;

      const copy = list.cloneNode(true);
      copy.addEventListener('scroll', () => this.updateArrows());
      this.slider.replaceChildren(copy);
      this.panel.classList.add('has-products');
      this.products.hidden = false;
      this.updateArrows();
    }

    /* Liquid serves 250 entries per page at most: the cards of the other
       pages are fetched and appended, the materials no product refers to
       (their panel would be empty) are removed, and what is left is shown by
       batches behind "See more". Each step fails open: a page that does not
       load is skipped, a missing list of referenced materials keeps them all. */
    async prepare() {
      const [ids, others] = await Promise.all([this.fetchReferenced(), this.fetchOtherPages()]);

      /* A page answered twice (wrong page key, cache) would double its cards:
         only materials the grid does not hold yet are appended. */
      const known = new Set([...this.grid.querySelectorAll('.materials__item')].map((item) => item.dataset.materialId));
      others.forEach((item) => {
        if (known.has(item.dataset.materialId)) return;
        known.add(item.dataset.materialId);
        this.grid.append(item);
      });
      this.fadeIn(this.grid.querySelectorAll('.materials__image'));

      if (ids) {
        this.grid.querySelectorAll('.materials__item').forEach((item) => {
          if (!ids.has(item.dataset.materialId)) item.remove();
        });
      }

      this.items = [...this.grid.querySelectorAll('.materials__item')];
      this.items.forEach((item) => (item.hidden = true));
      this.shown = 0;
      this.showMore(false);
      this.classList.add('is-ready');
    }

    /* The list comes from the same section as the sliders, asked without a
       filter value. Null when it cannot be had (request failed, filter not
       declared in Search & Discovery). */
    async fetchReferenced() {
      try {
        const html = await fetch(`${this.dataset.productsUrl}?section_id=materials-products`).then((response) =>
          response.text()
        );
        const list = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-material-ids]');
        return list ? new Set(list.dataset.materialIds.split(',').filter(Boolean)) : null;
      } catch (error) {
        return null;
      }
    }

    /* The key of the page parameter is the one Liquid hands over (see the
       header): a page that answers with another number than the one asked
       is the first page again, and is dropped rather than appended. */
    async fetchOtherPages() {
      const current = Number(this.dataset.currentPage) || 1;
      const pages = Number(this.dataset.pages) || 1;
      const param = this.dataset.pageParam || 'page';
      const requests = [];

      for (let page = 1; page <= pages; page++) {
        if (page === current) continue;
        const url = `${window.location.pathname}?${encodeURIComponent(param)}=${page}&section_id=${this.dataset.sectionId}`;
        requests.push(
          fetch(url)
            .then((response) => response.text())
            .then((html) => {
              const doc = new DOMParser().parseFromString(html, 'text/html');
              const index = doc.querySelector('materials-index');
              if (!index || Number(index.dataset.currentPage) !== page) return [];
              return [...doc.querySelectorAll('.materials__item')];
            })
            .catch(() => [])
        );
      }

      /* Kept in page order, whatever order the responses arrive in. */
      return (await Promise.all(requests)).flat();
    }

    /* Reveals the next batch. On a click, the focus moves to the first new
       card, so that keyboard users carry on from where the list grew. */
    showMore(moveFocus) {
      const next = this.items.slice(this.shown, this.shown + this.batch);
      next.forEach((item) => (item.hidden = false));
      this.shown += next.length;
      this.more.hidden = this.shown >= this.items.length;

      if (moveFocus && next.length) {
        next[0].querySelector('.materials__open').focus();
      }
    }

    clearProducts() {
      this.pending = null;
      this.products.hidden = true;
      this.panel.classList.remove('has-products');
      this.slider.replaceChildren();
    }

    /* One viewport per click, the snap points doing the alignment. The glide
       is the browser's own smooth scrolling rather than the frame by frame
       animation used elsewhere in the theme: it is the only one that agrees
       with `scroll-snap`, which would otherwise snap back at every frame —
       the original disables its snapping while it animates. The arrows follow
       through the scroll event; only the reduced-motion jump has to refresh
       them itself, since it may not fire one before the next frame. */
    step(direction) {
      const list = this.slider.firstElementChild;
      if (!list) return;

      const left = direction * list.clientWidth;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        list.scrollLeft += left;
        this.updateArrows();
        return;
      }

      list.scrollBy({ left: left, behavior: 'smooth' });
    }

    updateArrows() {
      const list = this.slider.firstElementChild;
      if (!list) return;
      const end = list.scrollWidth - list.clientWidth - 1;
      this.arrows.forEach((arrow) => {
        const backwards = Number(arrow.dataset.direction) < 0;
        arrow.disabled = backwards ? list.scrollLeft <= 0 : list.scrollLeft >= end;
      });
    }

    fadeIn(images) {
      images.forEach((image) => {
        if (image.complete) {
          image.classList.add('is-loaded');
          return;
        }
        image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
        image.addEventListener('error', () => image.classList.add('is-loaded'), { once: true });
      });
    }
  }

  if (!customElements.get('materials-index')) {
    customElements.define('materials-index', MaterialsIndex);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["notification-banner"] && !Shopify.designMode) return;
  try {
    
  /* Desktop rotation: every `interval` seconds the list slides up by one
     message. After the closing copy of the first message, the list jumps back
     to the real first one without transition. Nothing runs below 900px, where
     the CSS marquee shows every message.

     WCAG 2.2.2 (moving content longer than five seconds must be pausable):
     the rotation holds while the pointer is over the banner or while a link
     inside it has the focus, and resumes when both have left. A focused link
     also brings its own message into the window, since the other messages sit
     above or below the one-line frame where the keyboard could not see them. */
  class NotificationBanner extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.notification-banner__list');
      this.items = [...this.list.querySelectorAll(':scope > .notification-banner__item:not(.notification-banner__item--clone)')];
      this.count = this.items.length;
      this.index = 0;
      this.held = false;
      this.media = window.matchMedia('(max-width: 900px)');
      this.media.addEventListener('change', this.update);
      this.addEventListener('mouseenter', this.hold);
      this.addEventListener('mouseleave', this.release);
      this.addEventListener('focusin', this.onFocusIn);
      this.addEventListener('focusout', this.onFocusOut);
      this.update();
    }

    disconnectedCallback() {
      this.stop();
      this.media.removeEventListener('change', this.update);
    }

    update = () => {
      this.stop();
      if (this.held || this.media.matches || this.count < 2) return;
      const seconds = Number(this.dataset.interval) || 5;
      this.timer = setInterval(this.next, seconds * 1000);
    };

    hold = () => {
      this.held = true;
      this.stop();
    };

    release = () => {
      if (this.matches(':hover') || this.contains(document.activeElement)) return;
      this.held = false;
      this.update();
    };

    onFocusIn = (event) => {
      this.hold();
      const item = event.target.closest('.notification-banner__item');
      const at = this.items.indexOf(item);
      if (at < 0 || at === this.index) return;
      this.reset();
      this.index = at;
      this.list.style.setProperty('--notification-index', String(at));
    };

    onFocusOut = (event) => {
      if (this.contains(event.relatedTarget)) return;
      this.release();
    };

    next = () => {
      if (this.index >= this.count) this.reset();
      this.index += 1;
      this.list.style.setProperty('--notification-index', String(this.index));
      /* The last slide lands on the copy of the first message: once it is on
         screen (transition over), jump back to the real one. A timer rather
         than transitionend, which is unreliable when the tab is not drawn. */
      if (this.index === this.count) this.resetTimer = setTimeout(() => this.reset(), 450);
    };

    reset() {
      clearTimeout(this.resetTimer);
      this.list.classList.add('is-resetting');
      this.index = 0;
      this.list.style.setProperty('--notification-index', '0');
      void this.list.offsetHeight;
      this.list.classList.remove('is-resetting');
    }

    stop() {
      if (this.timer) clearInterval(this.timer);
      this.timer = null;
      clearTimeout(this.resetTimer);
    }
  }

  if (!customElements.get('notification-banner')) {
    customElements.define('notification-banner', NotificationBanner);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-faq"]) return;
  try {
    
  class FaqAccordion extends HTMLElement {
    connectedCallback() {
      window.addEventListener('hashchange', this.openFromHash);
      this.openFromHash();
    }

    disconnectedCallback() {
      window.removeEventListener('hashchange', this.openFromHash);
    }

    openFromHash = () => {
      const id = decodeURIComponent(window.location.hash.slice(1));
      if (!id) return;

      const target = document.getElementById(id);
      if (!target || !this.contains(target)) return;

      const item = target.closest('details');
      if (!item) return;

      item.open = true;
      requestAnimationFrame(() => target.scrollIntoView({ block: 'start' }));
    };
  }

  if (!customElements.get('faq-accordion')) {
    customElements.define('faq-accordion', FaqAccordion);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reassurance"] && !Shopify.designMode) return;
  try {
    
  class ReassuranceTabs extends HTMLElement {
    static mobile = window.matchMedia('(max-width: 900px)');

    connectedCallback() {
      this.addEventListener('click', this.onClick);
      ReassuranceTabs.mobile.addEventListener('change', this.sync);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      ReassuranceTabs.mobile.removeEventListener('change', this.sync);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    get toggles() {
      return this.querySelectorAll('.reassurance__toggle');
    }

    sync = () => {
      const isMobile = ReassuranceTabs.mobile.matches;

      this.toggles.forEach((toggle) => {
        toggle.disabled = !isMobile;

        if (isMobile) {
          this.setExpanded(toggle, toggle.getAttribute('aria-expanded') === 'true');
        } else {
          toggle.removeAttribute('aria-expanded');
          this.content(toggle).hidden = false;
        }
      });
    };

    onClick = (event) => {
      const toggle = event.target.closest('.reassurance__toggle');
      if (!toggle || !ReassuranceTabs.mobile.matches) return;

      this.setExpanded(toggle, toggle.getAttribute('aria-expanded') !== 'true');
    };

    onBlockSelect = (event) => {
      if (!ReassuranceTabs.mobile.matches || !this.contains(event.target)) return;

      const toggle = event.target.querySelector('.reassurance__toggle');
      if (toggle) this.setExpanded(toggle, true);
    };

    setExpanded(toggle, expanded) {
      toggle.setAttribute('aria-expanded', String(expanded));
      this.content(toggle).hidden = !expanded;
    }

    content(toggle) {
      return document.getElementById(toggle.getAttribute('aria-controls'));
    }
  }

  if (!customElements.get('reassurance-tabs')) {
    customElements.define('reassurance-tabs', ReassuranceTabs);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["show-looks"] && !Shopify.designMode) return;
  try {
    
  class ShowLooks extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.show-looks__panel');
      this.scroller = this.querySelector('.show-looks__scroller');
      this.slides = [...this.querySelectorAll('.show-looks__slide')];
      this.pushed = false;
      this.pixelTimers = [];

      this.fadeIn(this.querySelectorAll('.show-looks__image'));

      this.querySelectorAll('.show-looks__open').forEach((button) => {
        button.addEventListener('click', () => this.open(Number(button.dataset.index)));
      });

      this.querySelector('.show-looks__close').addEventListener('click', () => this.close());

      this.onKeyDown = (event) => {
        if (event.key === 'Escape' && !this.panel.hidden) this.close();
      };
      document.addEventListener('keydown', this.onKeyDown);

      this.onPopState = () => this.syncWithHash(false);
      window.addEventListener('popstate', this.onPopState);

      this.watchCurrentSlide();
      this.measureLayers();
      this.syncWithHash(true);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this.onKeyDown);
      window.removeEventListener('popstate', this.onPopState);
      this.clearPixelTimers();
      if (this.layerObserver) this.layerObserver.disconnect();
    }

    fadeIn(images) {
      images.forEach((image) => {
        if (image.complete) {
          image.classList.add('is-loaded');
          return;
        }
        image.addEventListener('load', () => image.classList.add('is-loaded'), { once: true });
        image.addEventListener('error', () => image.classList.add('is-loaded'), { once: true });
      });
    }

    indexFromHash() {
      const match = window.location.hash.match(/^#look-(\d+)$/);
      return match ? Number(match[1]) : null;
    }

    /* Follows the hash: on load it opens the panel on the right look, and on a
       back or forward step it opens, moves or closes it. */
    syncWithHash(initial) {
      const index = this.indexFromHash();
      if (index === null) {
        if (!this.panel.hidden) this.hidePanel();
        return;
      }
      const slide = this.slides.find((item) => Number(item.dataset.index) === index);
      if (!slide) return;
      if (this.panel.hidden) this.showPanel();
      this.scroller.scrollTop = slide.offsetTop;
      this.currentIndex = index;
      this.pixelate(slide);
      if (initial) this.pushed = false;
    }

    open(index) {
      const slide = this.slides.find((item) => Number(item.dataset.index) === index);
      if (!slide) return;
      window.history.pushState({ look: index }, '', `#look-${index}`);
      this.pushed = true;
      this.showPanel();
      this.scroller.scrollTop = slide.offsetTop;
      this.currentIndex = index;
      this.pixelate(slide);
    }

    /* Ports .PixelateImage of the original, timings included: the 20px
       thumbnail behind the slide holds the screen for 400ms after the image has
       loaded, then a canvas draws the image at 7% of its natural size, at 10%
       200ms later, and the sharp image replaces it 200ms after that. Blown up
       by image-rendering: pixelated, those two passes are the coarse stages.

       Plays once per look while the panel stays open: a look already sharp stays
       sharp when scrolling back to it. Closing the panel wipes that, so every
       look pixelates again on the next opening (asked for). Drawn from the image
       itself — no extra request. */
    pixelate(slide) {
      const canvas = slide.querySelector('.show-looks__canvas');
      const image = slide.querySelector('.show-looks__slide-image');
      if (!canvas || !image) return;
      if (image.classList.contains('is-revealed')) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        image.classList.add('is-revealed');
        return;
      }

      /* Leaving a look mid-sequence drops it: it stays on its thumbnail and
         starts over on the next visit, never half-pixelated. */
      this.clearPixelTimers();
      if (this.pixelSlide && this.pixelSlide !== slide) this.resetSlide(this.pixelSlide);
      this.pixelSlide = slide;

      if (!image.complete || !image.naturalWidth) {
        image.addEventListener('load', () => this.pixelate(slide), { once: true });
        return;
      }

      const context = canvas.getContext('2d');
      if (!context) {
        image.classList.add('is-revealed');
        return;
      }

      const draw = (scale) => {
        canvas.width = Math.max(1, Math.round(image.naturalWidth * scale));
        canvas.height = Math.max(1, Math.round(image.naturalHeight * scale));
        context.drawImage(image, 0, 0, canvas.width, canvas.height);
      };

      this.pixelTimers.push(
        window.setTimeout(() => {
          canvas.hidden = false;
          draw(0.07);
          this.pixelTimers.push(window.setTimeout(() => draw(0.1), 200));
          this.pixelTimers.push(
            window.setTimeout(() => {
              image.classList.add('is-revealed');
              canvas.hidden = true;
            }, 400)
          );
        }, 400)
      );
    }

    /* Feeds --slide-top / --slide-bottom, the heights each sticky block keeps
       clear for the other. Sizes change with the viewport and once the product
       thumbnails have loaded, hence the observer rather than a one-off read. */
    measureLayers() {
      const blocks = this.querySelectorAll('.show-looks__slide-top, .show-looks__slide-bottom');

      const apply = (block) => {
        const slide = block.closest('.show-looks__slide');
        if (!slide) return;
        const property = block.classList.contains('show-looks__slide-top')
          ? '--slide-top'
          : '--slide-bottom';
        slide.style.setProperty(property, `${block.offsetHeight}px`);
      };

      if (!('ResizeObserver' in window)) {
        blocks.forEach(apply);
        return;
      }

      this.layerObserver = new ResizeObserver((entries) => {
        entries.forEach((entry) => apply(entry.target));
      });
      blocks.forEach((block) => this.layerObserver.observe(block));
    }

    /* Drops an interrupted sequence by hiding its canvas. The look falls back to
       its thumbnail on its own, since is-revealed is only set at the very end. */
    resetSlide(slide) {
      const canvas = slide.querySelector('.show-looks__canvas');
      if (canvas) canvas.hidden = true;
    }

    /* Puts every look back to its thumbnail, sharp ones included, so the
       pixelation plays again on all of them the next time the panel opens.
       Called on close, once the panel is hidden, so nothing of it shows. */
    resetAllSlides() {
      this.slides.forEach((slide) => {
        this.resetSlide(slide);
        const image = slide.querySelector('.show-looks__slide-image');
        if (image) image.classList.remove('is-revealed');
      });
      this.pixelSlide = null;
    }

    clearPixelTimers() {
      this.pixelTimers.forEach((timer) => window.clearTimeout(timer));
      this.pixelTimers = [];
    }

    close() {
      if (this.pushed) {
        this.pushed = false;
        window.history.back();
        return;
      }
      window.history.replaceState(null, '', window.location.pathname + window.location.search);
      this.hidePanel();
    }

    showPanel() {
      this.panel.hidden = false;
      document.documentElement.style.overflow = 'hidden';
      this.setPageInert(true);
      this.setHeaderOffset();
      this.fadeIn(this.querySelectorAll('.show-looks__slide-image'));
      this.querySelector('.show-looks__close').focus();
    }

    /* The panel is a layer over the page, not a <dialog>: nothing confines the
       focus by itself. While it is open, everything behind it — the grid of
       this section, the other sections of the page, the footer — is `inert`,
       so Tab and the screen reader stay within the panel (WCAG 2.4.3). The
       header, visible above the panel, stays operable. */
    setPageInert(state) {
      const behind = [...document.querySelectorAll('#main > *, .footer-group')].filter((el) => !el.contains(this));
      behind.push(this.querySelector('.show-looks__list'));
      behind.forEach((el) => el.toggleAttribute('inert', state));
    }

    /* The panel sits below the header, so the name and the close button start
       where the header ends. */
    setHeaderOffset() {
      const header = document.querySelector('.header-group');
      if (!header) return;
      const bottom = header.getBoundingClientRect().bottom;
      if (bottom > 0) this.panel.style.setProperty('--show-looks-header', `${Math.round(bottom)}px`);
    }

    hidePanel() {
      this.panel.hidden = true;
      document.documentElement.style.overflow = '';
      this.setPageInert(false);
      this.clearPixelTimers();
      this.resetAllSlides();
      const index = this.currentIndex;
      const cell = index ? this.querySelector(`.show-looks__open[data-index="${index}"]`) : null;
      if (cell) cell.focus();
    }

    /* Keeps the hash on the look being read, without stacking history entries.
       A look is taller than the panel, so it never crosses an intersection
       ratio: the look holding the middle of the panel is the current one. */
    watchCurrentSlide() {
      let frame = null;
      this.scroller.addEventListener('scroll', () => {
        if (frame) return;
        frame = window.requestAnimationFrame(() => {
          frame = null;
          this.updateCurrentSlide();
        });
      });
    }

    updateCurrentSlide() {
      const middle = this.scroller.scrollTop + this.scroller.clientHeight / 2;
      const slide = this.slides.find(
        (item) => item.offsetTop <= middle && item.offsetTop + item.offsetHeight > middle
      );
      if (!slide) return;

      const index = Number(slide.dataset.index);
      if (index === this.currentIndex) return;
      this.currentIndex = index;

      if (this.panel.hidden) return;
      this.pixelate(slide);
      if (this.indexFromHash() === index) return;
      window.history.replaceState({ look: index }, '', `#look-${index}`);
    }
  }

  if (!customElements.get('show-looks')) {
    customElements.define('show-looks', ShowLooks);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["stockists"] && !Shopify.designMode) return;
  try {
    
  /* Filtre de la page des revendeurs, port de `StockistsSidebar` /
     `StockistContent` de marineserre.com. Tout est côté client : les cartes
     sont toutes rendues par Liquid, chacune avec `data-country` et
     `data-city`, et le composant ne fait que les copier dans le groupe de
     résultats, à la place des zones, selon les deux sélecteurs.

     Contrat de markup :
     - `[data-panel]`         : le panneau collant (reçoit `--stockists-sticky-top`)
     - `[data-country-select]`: le sélecteur de pays, options = tous les pays
     - `[data-city-select]`   : le sélecteur de ville, facultatif, rempli ici
     - `[data-field]`         : l'enveloppe de chaque sélecteur, dont le bouton
                                `[data-reset]` efface la valeur ; classes
                                `is-filled` (valeur choisie) et `is-disabled`
     - `[data-regions]`       : les groupes par zone, masqués pendant un filtre
     - `[data-results]`       : le groupe de résultats, `[data-results-title]`
                                et `[data-results-list]`
     - `[data-status]`        : annonce du nombre de résultats (lecteurs
                                d'écran), gabarits `data-status-one/-other`
                                de l'hôte, `[count]` remplacé. */
  class StockistFinder extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('[data-panel]');
      this.countrySelect = this.querySelector('[data-country-select]');
      this.citySelect = this.querySelector('[data-city-select]');
      this.regions = this.querySelector('[data-regions]');
      this.results = this.querySelector('[data-results]');
      this.resultsTitle = this.querySelector('[data-results-title]');
      this.resultsList = this.querySelector('[data-results-list]');
      this.status = this.querySelector('[data-status]');
      this.items = [...this.querySelectorAll('[data-regions] [data-country]')];

      this.measure = this.measure.bind(this);
      this.measure();
      window.addEventListener('resize', this.measure);

      if (!this.countrySelect) return;

      this.countrySelect.addEventListener('change', () => this.selectCountry(this.countrySelect.value));
      if (this.citySelect) {
        this.citySelect.addEventListener('change', () => this.render());
      }
      this.querySelectorAll('[data-reset]').forEach((button) => {
        button.addEventListener('click', () => this.clear(button.closest('[data-field]')));
      });
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.measure);
    }

    /* Le panneau se cale une gouttière sous le cadre du header, barre de
       liens rapides comprise, et ne bouge pas quand le header se replie :
       on rend au cadre replié ce qu'il a perdu (même calcul que
       `<core-intro>`). */
    measure() {
      if (!this.panel) return;
      const frame = document.querySelector('.header-group');
      if (!frame) return;
      const styles = getComputedStyle(document.documentElement);
      let height = frame.getBoundingClientRect().height;
      if (frame.classList.contains('is-collapsed')) {
        const large = parseFloat(styles.getPropertyValue('--header-height'));
        const small = parseFloat(styles.getPropertyValue('--header-height-collapsed'));
        height += large - small;
      }
      const gutter = parseFloat(styles.getPropertyValue('--gutter'));
      this.panel.style.setProperty('--stockists-sticky-top', gutter * 2 + height + 'px');
    }

    /* Un pays choisi : le sélecteur de ville reçoit les villes de ses
       revendeurs (triées, sans doublon) et s'active s'il y en a. */
    selectCountry(country) {
      if (this.citySelect) {
        const cities = [...new Set(
          this.items
            .filter((item) => item.dataset.country === country)
            .map((item) => item.dataset.city)
            .filter(Boolean)
        )].sort((a, b) => a.localeCompare(b));

        [...this.citySelect.options].slice(1).forEach((option) => option.remove());
        cities.forEach((city) => {
          const option = document.createElement('option');
          option.value = city;
          option.textContent = city;
          this.citySelect.append(option);
        });
        this.citySelect.selectedIndex = 0;
        this.citySelect.disabled = !country || cities.length === 0;
      }
      this.render();
    }

    /* Effacer un sélecteur : la ville ramène aux résultats du pays, le pays
       ramène aux zones (et vide la ville). */
    clear(field) {
      const select = field.querySelector('select');
      if (select === this.countrySelect) {
        this.countrySelect.selectedIndex = 0;
        this.selectCountry('');
      } else {
        this.citySelect.selectedIndex = 0;
        this.render();
      }
      select.focus();
    }

    render() {
      const country = this.countrySelect.value;
      const city = this.citySelect ? this.citySelect.value : '';

      this.querySelectorAll('[data-field]').forEach((field) => {
        const select = field.querySelector('select');
        field.classList.toggle('is-filled', select.value !== '');
        field.classList.toggle('is-disabled', select.disabled);
        field.querySelector('[data-reset]').hidden = select.value === '';
      });

      if (!country) {
        this.resultsList.replaceChildren();
        this.results.hidden = true;
        this.regions.hidden = false;
        this.status.textContent = '';
        return;
      }

      const matches = this.items.filter(
        (item) => item.dataset.country === country && (!city || item.dataset.city === city)
      );
      this.resultsTitle.textContent = city ? `${city}, ${country}` : country;
      this.resultsList.replaceChildren(...matches.map((item) => item.cloneNode(true)));
      this.regions.hidden = true;
      this.results.hidden = false;

      const template = matches.length === 1 ? this.dataset.statusOne : this.dataset.statusOther;
      this.status.textContent = template.replace('[count]', matches.length);
    }
  }

  if (!customElements.get('stockist-finder')) {
    customElements.define('stockist-finder', StockistFinder);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["values"]) return;
  try {
    
/* Pills of the introduction and the panel each one opens. */
  class ValuesWords extends HTMLElement {
    connectedCallback() {
      /* A panel closes three ways — its button, its veil, the Escape key — and
         only the first goes through the handler below. Watching the attribute
         itself catches all three with one rule. */
      this.observer = new MutationObserver((records) => {
        for (const record of records) {
          if (record.target.open) continue;

          const word = this.querySelector('[data-panel="' + record.target.id + '"]');
          if (word) word.removeAttribute('aria-expanded');
        }
      });

      for (const dialog of this.querySelectorAll('.values__dialog')) {
        this.observer.observe(dialog, { attributes: true, attributeFilter: ['open'] });
      }

      this.addEventListener('click', (event) => {
        const word = event.target.closest('.values__word');
        if (word) return this.open(word);

        const close = event.target.closest('.values__close');
        if (close) return close.closest('dialog').close();

        /* A click on the veil lands on the dialog itself, never on its
           contents: that is how a modal dialog reports its backdrop. */
        const dialog = event.target.closest('.values__dialog');
        if (dialog && event.target === dialog) dialog.close();
      });
    }

    open(word) {
      const dialog = this.querySelector('#' + word.dataset.panel);
      if (!dialog) return;

      word.setAttribute('aria-expanded', 'true');
      dialog.showModal();
    }

    disconnectedCallback() {
      if (this.observer) this.observer.disconnect();
    }
  }

  customElements.define('values-words', ValuesWords);

  /*
   * Cloud of words of the Values page, read off the original rather than
   * guessed: four rings of radius 95 in a world 200 units wide, each tilted by
   * a fixed pair of angles, three points travelling on each, the whole set
   * turning on two axes at once. An orthographic camera flattens it, so a
   * tilted ring projects to an ellipse — those are the long dotted curves.
   *
   * Everything below matches the original's figures: the tilts, the two speeds,
   * the 30 segments of a ring, the 2px dash and 5px gap measured on screen
   * rather than in the scene, the 10 pixel dots, the twenty pixels the labels
   * sit above their point, and the 0.004 the clock gains every frame.
   *
   * The sphere can be dragged, as on the original: the pointer sets a target
   * the current rotation eases towards, a tenth of the remaining angle per
   * frame, and what has been turned so far is folded into a held rotation each
   * time a new drag starts.
   *
   * Only the pale logo the original turns at the centre of the rings is left
   * out: it is a 3D model, #F4F4F4 on white, and all but invisible.
   */
  class ValuesConstellation extends HTMLElement {
    connectedCallback() {
      this.canvas = this.querySelector('canvas');
      this.labels = [...this.querySelectorAll('li')];
      this.context = this.canvas.getContext('2d');

      this.time = 0;
      this.radius = 95;
      this.pointSpeed = 0.3;

      this.rings = [
        { x: -0.5, y: 2.1 },
        { x: -4, y: -0.2 },
        { x: 0.5, y: 0.5 },
        { x: 0.5, y: -0.5 }
      ];

      let rest = this.labels.length % this.rings.length;
      const share = Math.floor(this.labels.length / this.rings.length);

      for (const ring of this.rings) {
        ring.count = share;
        if (rest > 0) {
          ring.count++;
          rest--;
        }
      }

      this.outline = [];
      for (let step = 0; step <= 30; step++) {
        const angle = (step / 30) * Math.PI * 2;
        this.outline.push([Math.cos(angle) * this.radius, Math.sin(angle) * this.radius, 0]);
      }

      this.held = [1, 0, 0, 0, 1, 0, 0, 0, 1];
      this.drag = { x: 0, y: 0 };
      this.target = { x: 0, y: 0 };
      this.down = false;

      this.onDown = this.onDown.bind(this);
      this.onMove = this.onMove.bind(this);
      this.onUp = this.onUp.bind(this);
      this.addEventListener('pointerdown', this.onDown);
      document.addEventListener('pointermove', this.onMove);
      document.addEventListener('pointerup', this.onUp);

      this.resizeObserver = new ResizeObserver(() => this.resize());
      this.resizeObserver.observe(this.canvas);
      this.resize();

      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.frame = requestAnimationFrame(() => this.draw());
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      document.removeEventListener('pointermove', this.onMove);
      document.removeEventListener('pointerup', this.onUp);
      cancelAnimationFrame(this.frame);
    }

    onDown(event) {
      event.preventDefault();

      /* Fold what the previous drags have turned into the held rotation, so
         the new one starts from zero. */
      this.held = this.multiply(this.rotation(this.drag.x, this.drag.y), this.held);
      this.drag = { x: 0, y: 0 };
      this.target = { x: 0, y: 0 };
      this.start = { x: event.clientX, y: event.clientY };
      this.down = true;
    }

    onMove(event) {
      if (!this.down) return;
      event.preventDefault();

      this.target = {
        x: ((event.clientY - this.start.y) / this.size) * 3,
        y: ((event.clientX - this.start.x) / this.size) * 3
      };
    }

    onUp() {
      this.down = false;
    }

    /* Rotation around x then y, in the order three.js composes its angles. */
    rotation(x, y) {
      const cx = Math.cos(x);
      const sx = Math.sin(x);
      const cy = Math.cos(y);
      const sy = Math.sin(y);

      return [
        cy, 0, sy,
        sx * sy, cx, -sx * cy,
        -cx * sy, sx, cx * cy
      ];
    }

    multiply(a, b) {
      const out = [];

      for (let row = 0; row < 3; row++) {
        for (let column = 0; column < 3; column++) {
          out[row * 3 + column] =
            a[row * 3] * b[column] +
            a[row * 3 + 1] * b[3 + column] +
            a[row * 3 + 2] * b[6 + column];
        }
      }

      return out;
    }

    apply(matrix, point) {
      return [
        matrix[0] * point[0] + matrix[1] * point[1] + matrix[2] * point[2],
        matrix[3] * point[0] + matrix[4] * point[1] + matrix[5] * point[2],
        matrix[6] * point[0] + matrix[7] * point[1] + matrix[8] * point[2]
      ];
    }

    /* The world is 200 units wide whatever the canvas measures. */
    toScreen(point) {
      const scale = this.size / 200;
      return { x: point[0] * scale, y: -point[1] * scale, z: point[2] };
    }

    shortest(angle, target) {
      const difference = (angle - target) % (Math.PI * 2);
      if (difference > Math.PI) return difference - Math.PI * 2;
      if (difference < -Math.PI) return difference + Math.PI * 2;
      return difference;
    }

    resize() {
      this.ratio = Math.min(2, devicePixelRatio || 1);
      this.size = this.canvas.clientWidth;
      this.canvas.width = this.size * this.ratio;
      this.canvas.height = this.size * this.ratio;
      this.context.setTransform(this.ratio, 0, 0, this.ratio, this.size / 2, this.size / 2);
    }

    draw() {
      const context = this.context;
      const half = this.size / 2;
      context.clearRect(-half, -half, this.size, this.size);

      this.drag.x -= this.shortest(this.drag.x, this.target.x) / 10;
      this.drag.y -= this.shortest(this.drag.y, this.target.y) / 10;

      const world = this.multiply(
        this.multiply(this.rotation(this.drag.x, this.drag.y), this.held),
        this.rotation(this.time, this.time)
      );

      /* Dashes are measured along the drawn line, as the original measures
         them on screen and not in the scene. */
      context.setLineDash(matchMedia('(max-width: 900px)').matches ? [1, 5] : [2, 5]);
      context.strokeStyle = 'rgb(0, 0, 0)';
      context.lineWidth = 1;
      context.fillStyle = 'rgb(0, 0, 0)';

      const depths = [];
      let index = 0;

      for (const [order, ring] of this.rings.entries()) {
        const matrix = this.multiply(world, this.rotation(ring.x, ring.y));

        context.beginPath();
        this.outline.forEach((point, step) => {
          const screen = this.toScreen(this.apply(matrix, point));
          if (step === 0) context.moveTo(screen.x, screen.y);
          else context.lineTo(screen.x, screen.y);
        });
        context.stroke();

        for (let position = 0; position < ring.count; position++) {
          const speed = ((order + position + 1) / 3) * this.time * this.pointSpeed;
          const angle = speed + (2 * position * Math.PI) / ring.count;
          const point = this.apply(matrix, [
            Math.cos(angle) * this.radius,
            Math.sin(angle) * this.radius,
            0
          ]);

          const screen = this.toScreen(point);
          const diameter = 10 / this.ratio;

          context.beginPath();
          context.arc(screen.x, screen.y, diameter / 2, 0, Math.PI * 2);
          context.fill();

          const label = this.labels[index];
          if (label) {
            label.style.transform =
              'translate3d(' + screen.x + 'px, ' + (screen.y - 20) + 'px, 0px)';
          }

          depths.push({ index: index, z: point[2] });
          index++;
        }
      }

      /* Nearest label on top, as on the original: the depths sorted the other
         way round, then the stacking order read off that list. */
      depths.sort((a, b) => a.z - b.z);
      depths.forEach((entry, order) => {
        const label = this.labels[entry.index];
        if (label && label.style.zIndex !== String(order)) label.style.zIndex = order;
      });

      if (!this.motion.matches) this.time += 0.004;
      this.frame = requestAnimationFrame(() => this.draw());
    }
  }

  customElements.define('values-constellation', ValuesConstellation);

  } catch(e) { console.error(e); }
})();
})();
